import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';
import { Base64 } from 'js-base64';
import { ErrorType, StatusCode } from "../assets/constants/constants";
import { clearLocalStorage, customHistory, getDevice, hideLoader, ignoreErrorForApi } from '../lib/utils';
import { BASE_URL, endPoints } from './urls';
 
const Api = (type?: boolean | string, customHeaders?: any) => {

  const selectedLanguage = localStorage.getItem('locale');

  let language;

  if (selectedLanguage === null) {
    language = 'en-US';
  } else {
    language = selectedLanguage;
  }

  // Default config options
  const createOptions = () => {
    return {
      headers: {
        'Content-Type': 'application/json',
        ...customHeaders,
      },
    };
  };

  // Create instance
  const instance = axios.create(createOptions());
  // Set the AUTH token for any request
  let isRefreshing = false;
  // Store of callbacks to be executed after token refresh
  let refreshSubscribers:any = [];
  // Function to add callbacks to the store
  const subscribeTokenRefresh = (callback:any) => {
    refreshSubscribers.push(callback);
  }
  // Function to execute callbacks after token refresh
  const onTokenRefreshed = (token:any) => {
    refreshSubscribers.forEach((callback:any) => callback(token));
    refreshSubscribers = [];
  }

  instance.interceptors.request.use(async function (config) {
    // await fetchRefreshToken();
    const appUrl: any = config.url;
    const urlString = appUrl.split('/');
    const fileName = urlString[urlString.length - 1].replace(/[^a-zA-Z0-9]/g, '').substring(0, 50);
    if (import.meta.env.VITE_APP_URL == 'http://localhost:5173') {
      config.url = `${import.meta.env.VITE_APP_URL}/public/${fileName}.json`;
    }
    
    if (type) { 
      const access_token:any = localStorage.getItem('access_token');
      if (type === 'ai') {
        const cred=`${import.meta.env.VITE_AI_USER_NAME}:${import.meta.env.VITE_AI_PASSWORD}`;
        config.headers.Authorization = access_token ? `Basic ${Base64.encode(cred)}` : '';
      }else{
        config.headers.Authorization = access_token ? `oauth ${access_token}` : '';
      }
    } else {
      const token:any = localStorage.getItem('token');
      config.headers['Accept-Language'] = language;
      config.headers.Authorization = token ? `Bearer ${token}` : '';
      config.headers.platformType = getDevice();
    }
    return config;
  });

  // Modify response
 
  instance.interceptors.response.use(
    response => {
      hideLoader();
      return response.data;
    },
    async function (error:any) {
      const originalRequest = error.config;
      const {status} = error.response;
      // Do something with response error
      if(status === StatusCode.ERR_BAD_REQUEST &&   !ignoreErrorForApi(originalRequest.url)){ // tesing purpose
        // customHistory.push(`/error/${ErrorType.invalidRequest}`)
        return Promise.resolve(error?.response?.data);
      }
      if(error.code === StatusCode.ERR_NETWORK && !ignoreErrorForApi(originalRequest.url)){
        customHistory.push(`/error/${ErrorType.networkError}`)
      }
      if(status === StatusCode.UN_AUTHORIZED && !originalRequest._retry){
          if (isRefreshing) {
            return new Promise(resolve => {
              subscribeTokenRefresh(() => {
                resolve(instance(originalRequest));
              });
            });
          }
          originalRequest._retry = true;
          isRefreshing = true;
          
          return new Promise((resolve, reject) => {
              fetchAuthSession({forceRefresh: true})
              .then((cognito:any)=>{
                const accessToken=cognito
                const updatedAccessToken = accessToken?.tokens?.accessToken.toString();
                if (updatedAccessToken !== undefined) {
                  localStorage.setItem('token', updatedAccessToken)
                  axios.get(`${BASE_URL}${endPoints.ALM_REFRESH_TOKEN}`,{ 
                      headers: { 
                        'Authorization': 'Bearer '+ updatedAccessToken,
                        'Accept-Language':language,
                        'Content-Type': 'application/json',
                      } 
                    })
                    .then((learnerRes:any) => {
                      const  {access_token}  = learnerRes?.data?.data;
                      localStorage.setItem('access_token', access_token);
                      onTokenRefreshed(access_token);
                      resolve(instance(originalRequest));
                    })
                    .catch(refreshError => {
                      // Handle refresh failure (e.g., redirect to login)
                      reject(refreshError);
                      clearLocalStorage()
                      customHistory.push(`/?sessionExpire=alm`)
                    })
                    .finally(() => {
                      isRefreshing = false;
                    }); 
                }else{
                  clearLocalStorage()
                  customHistory.push(`/?sessionExpire=cognito`)
                }
              })
              .catch(refreshError => {
                clearLocalStorage()
                // Handle refresh failure (e.g., redirect to login)
                reject(refreshError); 
                customHistory.push(`/?sessionExpire=cognito`)
              })
              .finally(() => {
                isRefreshing = false;
              });
            });         
      }
      return Promise.reject({status:StatusCode.ERR_NETWORK,data:[],code: error?.response?.data?.code});
    }
  );
  
  return instance;
};

export default Api;
